import { useEffect, useState } from "react";
import { FaArrowRight, FaBriefcase, FaCheck, FaDownload, FaGift, FaUserSecret } from "react-icons/fa";
import Form from "./FormAmbassador.jsx";
import "./Ambassador.css";
import wefLogo from "../Assets/wef-detective-logo.png";
import mascot from "../Assets/wef-detective-mascot.png";
import heroVideo from "../Assets/wef-back-sep-2026.webm";
import bannerAmbassador from "../Assets/banner-ambassador.webp";

const Ambassador = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [sticky, setSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => setSticky(window.scrollY > 50);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="detective-subpage ambassador-page">
      <header className={`ambassador-header ${sticky ? "is-sticky" : ""}`}>
        <div className="ambassador-shell ambassador-header-inner">
          <a href="/" className="ambassador-brand" aria-label="World Education Festival home">
            <img src={wefLogo} alt="World Education Festival" />
          </a>
          <button className="ambassador-menu-button" type="button" onClick={() => setMenuOpen((value) => !value)} aria-expanded={menuOpen}>
            Menu
          </button>
          <nav className={menuOpen ? "is-open" : ""} aria-label="Ambassador navigation">
            <a href="#home" onClick={closeMenu}>Beranda</a>
            <a href="#wef" onClick={closeMenu}>Mission Brief</a>
            <a className="ambassador-nav-cta" href="#daftar" onClick={closeMenu}>Daftar Sekarang</a>
          </nav>
        </div>
      </header>

      <section id="home" className="ambassador-hero">
        <video className="ambassador-hero-video" src={heroVideo} autoPlay muted loop playsInline preload="metadata" aria-hidden="true" />
        <div className="ambassador-hero-shade" />
        <div className="ambassador-shell ambassador-hero-layout">
          <div className="ambassador-hero-copy">
            <p className="ambassador-eyebrow"><FaUserSecret /> Recruitment case 2026</p>
            <h1>Join the WEF Ambassador Squad</h1>
            <p>Jadi bagian dari misi World Education Festival, ajak calon mahasiswa hadir, dan dapatkan bonus dari setiap peserta yang berhasil terdaftar.</p>
            <div className="ambassador-hero-actions">
              <a href="#daftar">Daftar Jadi Ambassador <FaArrowRight /></a>
              <a href="#wef" className="is-secondary">Baca Mission Brief</a>
            </div>
            <ul>
              <li><FaCheck /> Bonus peserta</li>
              <li><FaCheck /> Materi promosi</li>
              <li><FaCheck /> Kode referral personal</li>
            </ul>
          </div>
          <a href="#daftar" className="ambassador-promo" aria-label="Daftar Ambassador World Education Festival">
            <img src={bannerAmbassador} alt="Join Ambassador World Education Festival" />
          </a>
        </div>
        <img className="ambassador-hero-mascot" src={mascot} alt="Detektif WEF" />
      </section>

      <section id="wef" className="ambassador-brief">
        <div className="ambassador-shell">
          <div className="ambassador-section-heading">
            <p>Case file 01</p>
            <h2>Mission Brief</h2>
            <span>Pahami keuntungan, persyaratan, dan tugas sebelum bergabung dengan tim Ambassador WEF.</span>
          </div>

          <div className="ambassador-brief-grid">
            <article>
              <div className="ambassador-card-icon"><FaGift /></div>
              <span>Evidence 01</span>
              <h3>Benefit</h3>
              <ul>
                <li>Mendapat bonus sebesar IDR 10k per peserta.</li>
                <li>Bonus dapat dicairkan ketika peserta berhasil daftar dan hadir di WEF.</li>
                <li>Minimal 5 dan maksimal 25 peserta untuk pencairan bonus.</li>
                <li>Bonus ditransfer paling lambat satu minggu setelah event.</li>
              </ul>
            </article>
            <article>
              <div className="ambassador-card-icon"><FaUserSecret /></div>
              <span>Evidence 02</span>
              <h3>Syarat</h3>
              <ul>
                <li>Berusia minimal 18 tahun.</li>
                <li>Mengisi formulir pendaftaran Ambassador.</li>
                <li>Menggunakan kode referral personal untuk registrasi peserta.</li>
              </ul>
            </article>
            <article>
              <div className="ambassador-card-icon"><FaBriefcase /></div>
              <span>Evidence 03</span>
              <h3>Job Desk</h3>
              <ul>
                <li>Mengajak peserta menghadiri World Education Festival.</li>
                <li>Membantu peserta mendaftar dengan kode referral hingga registrasi berhasil.</li>
              </ul>
            </article>
          </div>

          <a className="ambassador-material-button" href="https://drive.google.com/drive/folders/1qfRjPHZRbThZ8Oc0e6CtbopA7yXIyhLI" target="_blank" rel="noopener noreferrer">
            <FaDownload /> Download Material Promosi
          </a>
        </div>
      </section>

      <Form />

      <footer className="ambassador-footer">
        <img src={wefLogo} alt="World Education Festival" />
        <p>© 2026 NIEC — World Education Festival Ambassador Program.</p>
      </footer>
    </div>
  );
};

export default Ambassador;
